<template>
  <el-row class="page">
    <el-pagination
      background
      :total="total"
      :current-page="page"
      :page-size="pageSize"
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next, jumper"
    >
    </el-pagination>
  </el-row>
</template>
<script>
import { page } from "@/libs/model";
export default {
  props: {
    total: { type: Number, default: 0 },
    page: { type: Number, default: page.page },
    pageSize: { type: Number, default: page.pageSize }
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("current-change", val);
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  padding: 0.5rem;
  text-align: right;
}
</style>
